// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__31fJC","list":"BalanceDue_list__B3bsi","listRow":"BalanceDue_listRow__2uFZR","total":"BalanceDue_total__1Qzo1"};